import SectionTitle from "@/components/base/SectionTitle";
import CollectionCard from "@/components/base/CollectionCard";
import { collections } from "@/mocks/collections";

export default function FeaturedCollections() {
  const featured = [...collections]
    .sort((a, b) => Number(b.hot) - Number(a.hot))
    .slice(0, 6);

  return (
    <section
      className="w-full bg-background-100 border-y border-background-200"
      aria-labelledby="home-featured-title"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-16 md:py-20">
        <SectionTitle
          eyebrow="FEATURED"
          title="编辑精选合集"
          desc="从五个分类里挑出信息量最满的几篇，涵盖同一条镜头反复拍摄、外景连续夜戏、以及容易被忽略的隐藏呼应。"
          linkTo="/collections"
          linkLabel="浏览更多"
        />
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {featured.map((item) => (
            <CollectionCard key={item.id} collection={item} />
          ))}
        </div>
      </div>
    </section>
  );
}